import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { actionKey, apiPost, qk, resetActionKey } from "@/shared/api";

type WithdrawCreate = components["schemas"]["WithdrawCreate"];

/**
 * Заявка на вывод.
 *
 * Баланс здесь не списывается — списание происходит при подтверждении
 * администратором (ТЗ §7). Но `wallet` всё равно инвалидируется: заявка
 * уменьшает `available_for_withdrawal`, и следующая форма обязана это учесть.
 */
const ACTION = "withdraw";

export function useCreateWithdraw() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: WithdrawCreate) =>
      apiPost("/api/v1/wallet/withdraw", { body: payload, idempotencyKey: actionKey(ACTION) }),
    onSuccess: (request) => {
      resetActionKey(ACTION);
      client.setQueryData(qk.withdrawalRequest(request.id), request);
      void client.invalidateQueries({ queryKey: qk.wallet() });
      void client.invalidateQueries({ queryKey: ["activity"] });
    },
  });
}
